import { useSyncExternalStore } from "react";

export type DeviceClass = "desktop" | "mobile";

const mobileQuery = "(max-width: 767px)";

function subscribe(onChange: () => void) {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return () => undefined;
    }

    const mediaQuery = window.matchMedia(mobileQuery);
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
}

function getSnapshot(): DeviceClass {
    return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(mobileQuery).matches ? "mobile" : "desktop";
}

function getServerSnapshot(): DeviceClass {
    return "desktop";
}

export function useDeviceClass(): DeviceClass {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
